import { inject } from 'readuz';
import { DIReader } from './common';
import { ITrackPayload } from './track';

export type OnTrack = (payload: ITrackPayload) => void;
export const onTrack: DIReader<OnTrack> = inject(
    env => env.trackAction,
    env => env.log,
    (trackAction, log) => (payload) => {
        log('OnTrack', payload);
        trackAction(payload);
    },
);
